var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.19434,
    cy: 9.85742,
    r: 9,
    fill: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1511 8.13144H11.6595V7.14475C11.6595 5.78345 10.5557 4.67969 9.1944 4.67969C7.8331 4.67969 6.72934 5.78679 6.72934 7.14809V8.13479H6.23767C5.69582 8.13479 5.25098 8.57963 5.25098 9.12148V14.0483C5.25098 14.5901 5.69582 15.0349 6.23767 15.0349H12.1511C12.693 15.0349 13.1378 14.5901 13.1378 14.0483V9.11813C13.1378 8.57629 12.693 8.13144 12.1511 8.13144ZM10.7229 8.13144H7.66587V7.14475C7.66587 6.30188 8.35153 5.61621 9.1944 5.61621C10.0373 5.61621 10.7229 6.30188 10.7229 7.14475V8.13144Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lockIcon.ae8a0bc372a87b18bb84861c50819c50.svg";
export { ForwardRef as ReactComponent };